import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function NoUserModal({ onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleConfirm = () => {
    // Save the current URL so you can redirect back after login
    sessionStorage.setItem("routeback", location.pathname + location.search);

    // Navigate to login page
    navigate("/login");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center space-y-4 m-8">
        <h2 className="text-xl font-bold">Login Required</h2>
        <p className="text-sm text-gray-600">Please login to join.</p>
        <div className="flex justify-between space-x-4">
          <button
            className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg font-medium"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-blue-600 text-white py-2 rounded-lg font-medium"
            onClick={handleConfirm}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
